import Accordion from "../ui/Accordion";

const LABEL = { "en-IN": "Questions and answers", "hi-IN": "अक्सर पूछे जाने वाले सवाल" };

/** The page's FAQ plus its FAQPage JSON-LD, both from the one chunk.faq list. */
export default function Faq({ items = [], lang }) {
  if (items.length === 0) return null;

  const ld = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map(({ q, a }) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: { "@type": "Answer", text: a },
    })),
  }).replace(/</g, "\\u003c");

  return (
    <section className="tpl-section" aria-labelledby="tpl-faq">
      <h2 id="tpl-faq" className="tpl-section__title">
        {LABEL[lang] ?? LABEL["en-IN"]}
      </h2>
      <Accordion
        items={items}
        getKey={(item) => item.q}
        render={(item) => <p>{item.a}</p>}
      />
      <script data-seo="" type="application/ld+json" dangerouslySetInnerHTML={{ __html: ld }} />
    </section>
  );
}
